<template>
    <div class="px-4 mt-6">
        <div class="max-w-xl mx-auto">
            <InputSearch v-model="searchTerm" @onSearch="onSearch" />
        </div>
        <div class="max-w-xl mx-auto mt-4 mb-4 lg:mt-8 grid grid-cols-1 gap-4">
            <template v-if="orders.length > 0">
                <OrderItem v-for="(order, index) in orders.slice().reverse()" :key="`${order.tranId}-${index}`" :order="order"
                    @click="clickOrder(order)">
                </OrderItem>
            </template>
            <template v-else>
                <div class="mt-24 lg:mt-16">
                    <img src="@/assets/image/foods.svg" class="mx-auto lg:h-25 w-auto" />
                    <div class="text-a-brown-9f8273 text-14 lg:text-16 font-main text-center mt-2 lg:mt-6">
                        You don't have anything in my order yet!
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
// composable
import { inject, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import Util from '@/helper/Utility.js';
import useGuestOrderTracking from '../../composable/useGuestOrderTracking'
import useLoadingModal from '@/helper/composable/modal/useLoadingModal'
import useErrorModal from '@/helper/composable/modal/useErrorModal'
import {userOrderDeliveryDetailModal} from "../../composable/userOrderDetailModal"

// components
import InputSearch from './InputSearch.vue'
import OrderItem from './OrderItem.vue'

export default {
    name: 'SearchOrder',
    components: {
        InputSearch,
        OrderItem
    },
    setup: function () {
        //#region init
        const { lbl } = inject("LocaleStore")
        const modalStore = inject("ModalStore")
        const { showApiErrorModal, showErrorModal, onClickErrorModalClose } = useErrorModal(modalStore)
        const orderDeliveryDetailModal = userOrderDeliveryDetailModal(modalStore)
        const { showLoadingModal, hideLoadingModal } = useLoadingModal(modalStore)
        const { events, items, getTrackingOrders } = useGuestOrderTracking()
        const searchTerm = ref("") // test 0811111111
        const route = useRoute()
        //#endregion

        //#region setup events
        events.onLoading = showLoadingModal
        events.onLoaded = hideLoadingModal
        events.onError = (err) => {
            showApiErrorModal(err)
        }
        //#endregion

        //#region methods
        const onSearch = function () {
            
            getTrackingOrders(searchTerm.value)
        }
        const clickOrder = function (order) {
            // console.log(order);
            orderDeliveryDetailModal
                .clearModal()
                .setOrderDetail(order.items)
                .setOrderItem(order)
                .show()
        }
        //#endregion

        onMounted(()=>{
            searchTerm.value = route.query?.tranid ?? ""
            const from = route.query?.from ?? ""
  
            if (!Util.isEmptyStr(searchTerm.value)) onSearch();

            if (from == "shoppingcart") {
                showErrorModal(lbl.value.myOrder.please_wait);
                onClickErrorModalClose(()=> {
                    onSearch();
                })
            }
        })

        return {
            searchTerm,
            orders: items,
            onSearch,
            clickOrder,
        }
    },
}
</script>
